import { fetch, json, xray } from '@ux/drivers';

export default () => json()(xray()(fetch));
